import {
	ArrayNotEmpty,
	IsArray,
	IsBoolean,
	IsEmail,
	IsInt,
	IsNotEmpty,
	IsNumber,
	IsOptional,
	IsString,
	IsUUID,
	Min,
	ValidateNested,
} from 'class-validator';
import { Type } from 'class-transformer';

export class JoinLobbyDto {
	@IsUUID('4')
	@IsNotEmpty()
	id: string;

	@IsOptional()
	@IsString()
	password?: string;

	@IsOptional()
	@IsString()
	source?: string;
}

export class UpdateLobbyUserItemDto {
	@IsUUID('4')
	@IsNotEmpty()
	id: string;

	@IsUUID('4')
	@IsNotEmpty()
	user_id: string;

	@IsBoolean()
	is_hide: boolean;

	@IsOptional()
	@IsEmail()
	user_email?: string;

	@IsOptional()
	@IsBoolean()
	isNew?: boolean;
}

export class UpdateLobbyUsersDto {
	@IsArray()
	@ArrayNotEmpty()
	@ValidateNested({ each: true })
	@Type(() => UpdateLobbyUserItemDto)
	items: UpdateLobbyUserItemDto[];
}

export class UpdateLobbyPriorityDto {
	@IsNumber()
	priority: number;
}

export class AddTeamToLobbyDto {
	@IsString()
	@IsNotEmpty()
	name: string;
}

export class InitiateRevivalDto {
	@IsInt()
	@Min(1)
	reviveCount: number;
}

export class UpdateRevivalCountDto {
	@IsInt()
	@Min(0)
	revivalCount: number;
}

export class CreateLobbySourceDto {
	@IsUUID('4')
	@IsNotEmpty()
	lobbyId: string;

	@IsString()
	@IsNotEmpty()
	keyword: string;
}

export class GetLobbiesBySlateDto {
	@IsUUID('4')
	@IsNotEmpty()
	eventId: string;

	@IsOptional()
	@IsUUID('4')
	slateId?: string;
}
export class LobbyUserDto {
	user_id: string;
	user_email?: string;
	id?: string;
	country?: string | null;
}

export class LobbySponsorDto {
	id: string;
	img_variants?: Record<string, string> | null;
	url?: string | null;
}

export class LobbyByEventDto {
	id: string;
	name: string;
	type: string;
	is_private: boolean;
	lobby_users?: LobbyUserDto[] | null;
	game_start_date?: Date | string | null;
	access_password?: string | null;
	event_id: string;
	description?: string | null;
	prize?: string | null;
	img_variants?: Record<string, string> | null;
	logo_img_variants?: Record<string, string> | null;
	header_img_variants?: Record<string, string> | null;
	carousel_img_variants?: Record<string, string> | null;
	banner_url?: string | null;
	sponsor?: LobbySponsorDto | null;
}
